import { render, staticRenderFns } from "./index.vue?vue&type=template&id=43146c64&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=43146c64&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43146c64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43146c64')) {
      api.createRecord('43146c64', component.options)
    } else {
      api.reload('43146c64', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=43146c64&scoped=true", function () {
      api.rerender('43146c64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pointsMall/creatProduct/index.vue"
export default component.exports